import {withLeaflet, MapLayer} from "react-leaflet";
import L, {ImageOverlay} from "leaflet";
import {ImageOverlayRotated} from "../../../types/imageOverlayRotated"

import {QuadrilateralCornersType} from "../../../types/shape";
import {switchPosition} from "../../../helpers/shapeHelper";

type QuicklookPreviewImageOverlayPropsType = {
  url: string | HTMLImageElement,
  corners: QuadrilateralCornersType,
  attribution?: string,
  opacity?: number,
  zIndex?: number,
	className?: string,
  onClick?: any
};

class QuicklookPreviewImage extends MapLayer<ImageOverlay, QuicklookPreviewImageOverlayPropsType> {
  createLeafletElement() {
    const {
      className,
      url,
      corners,
      opacity,
      onClick
      // @ts-ignore
    } = this.props;
    const {
      upLeft,
      upRight,
      bottomLeft
    } = corners;

    return new ImageOverlayRotated(
      url,
      L.latLng(switchPosition(upLeft)),
      L.latLng(switchPosition(upRight)),
      L.latLng(switchPosition(bottomLeft)),
      {
        className,
        opacity,
        zIndex: 200,
        interactive: !!onClick,
        onClick
      }
    );
  }
}

export default withLeaflet<QuicklookPreviewImageOverlayPropsType, QuicklookPreviewImage>(QuicklookPreviewImage);
